// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-23881c38]{background-color:#fa3e3e;border-radius:2rem;color:#fff;padding:0 7px;font-size:10px;position:absolute;top:0;right:0}.menu-item-basket a[data-v-23881c38]{padding:0 8px!important}", ""]);
// Exports
module.exports = exports;
